import { supabase } from '@/lib/supabase';
import { readDashboardPages } from '../dashboardData.js';
import { productionOverheadLines } from '../productionCostOverhead.js';
import { flattenProduction } from '../dashboardMetrics.js';

const all = (table, select, signal) => readDashboardPages(() => supabase.from(table).select(select, { count: 'exact' }).order('id'), signal);
export async function loadProductionDashboard(signal) {
  const rows = [];
  for (let offset = 0; ; offset += 100) {
    const { data, error } = await supabase.rpc('mfg_production_order_tree_page', { p_limit: 100, p_offset: offset }).abortSignal(signal);
    if (error) throw error;
    const page = data || [];
    // Older RPCs lack these fields: never silently label all production as unfinished.
    if (page.some((o) => (o.products || []).some((r) => typeof r.manufacturing_complete !== 'boolean'))) {
      throw new Error('El seguimiento de fabricación de la base de datos necesita actualizarse.');
    }
    rows.push(...page);
    if (page.length < 100) break;
  }
  const costs = await readDashboardPages(() => supabase.from('mfg_production_order_cost_lines')
    .select('id, production_order_product_id, line_type, source_line_id, process_source_line_id, process_name_snapshot, name_snapshot, total_cost, process:mfg_manufacturing_processes(is_overhead)', { count: 'exact' })
    .order('id'), signal);
  const byProduct = new Map();
  for (const line of costs) {
    if (!byProduct.has(line.production_order_product_id)) byProduct.set(line.production_order_product_id, []);
    byProduct.get(line.production_order_product_id).push(line);
  }
  return flattenProduction(rows).map(row => ({ ...row, overhead_lines: productionOverheadLines([{ ...row, cost_lines: byProduct.get(row.id) || [] }]) }));
}

export async function loadDashboard(signal, onBlock) {
  const jobs = {
    production: () => loadProductionDashboard(signal),
    processes: () => readDashboardPages(() => supabase.from('mfg_production_order_cost_lines').select('id, production_order_product_id, supplier_id, supplier_name_snapshot, name_snapshot, received_date, delivered_date, received_quantity, delivered_quantity, excludes_manufacturing, process:mfg_manufacturing_processes(excludes_manufacturing)', { count: 'exact' }).eq('line_type', 'process').order('id'), signal),
    materials: () => all('mfg_production_material_orders', 'id, production_order_id, quantity, confirmed_quantity, expected_delivery_date, content, created_at', signal),
  };
  await Promise.all(Object.entries(jobs).map(async ([key, job]) => {
    try { const data = await job(); if (!signal.aborted) onBlock(key, { data, error: null }); }
    catch (error) { if (!signal.aborted) onBlock(key, { data: null, error: error.message || 'Error de conexión' }); }
  }));
}
